import plugin from './src/sequence.plugin.js';
export default plugin;